import api from "../../../services/api";
import { imagemURL } from "../../../services/variables";
import Loading from "../others/Loading";
import { useQuery } from "react-query";
import styles from "../../../styles/module/news-unique.module.css";
import { FaTrophy } from "react-icons/fa";
import { categoryColors } from "../../../utils";

export default function NewsDestaques({ excludeId }) {
  const { data, isLoading, isError } = useQuery(
    "news-all",
    async () => {
      const response = await api.get(`/news`);
      return response.data.res;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos
    }
  );

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return <p>Erro ao carregar as notícias...</p>;
  }

  return (
    <div className={styles.news_destaque_container}>
      <h2>
        <FaTrophy /> Veja também
      </h2>

      <aside>
        {data?.length > 0 ? (
          data
            .filter((news) => String(news.SLUG) !== String(excludeId))
            .sort((a, b) => new Date(b.DATA_POST) - new Date(a.DATA_POST))
            .slice(0, 3)
            .map((news) => (
              <a
                href={`/noticia/${news.SLUG}`}
                target="_top"
                rel="noopener noreferrer"
                key={news.ID}
                className={styles.link_container}
              >
                <div>
                  <img
                    alt={news.TITULO}
                    src={imagemURL + news.IMG}
                    loading="lazy"
                  />
                </div>
                <div className={styles.news_content}>
                  <p style={{ background: categoryColors[news.CATEGORIA] }}>{news.CATEGORIA}</p>
                  <h4>{news.TITULO}</h4>
                </div>
              </a>
            ))
        ) : (
          <></>
        )}
      </aside>
    </div>
  );
}
